<template>
  <section class="container-sarah">
    <div class="align columns is-vcentered">
      <div class="colum img view-desktop">
        <img
          class="login-section_logo"
          src="~@/assets/images/banners/documents-sarah_Laudos.svg"
          alt="Doutores"
        />
      </div>
      <div class="column text">
        <h3>{{ $t('documentos.laudos.subtitulo') }}</h3>

        <p>
          {{ $t('documentos.laudos.descricao') }}
        </p>

        <b-button
          class="btn-orange"
          tag="router-link"
          :to="{ name: 'MedicalReport' }"
        >
          {{ $t('botoes.solicitar') }}
        </b-button>
      </div>
    </div>
    <!-- table of content -->
    <tablelist
      class="table"
      :data="getRelatorios"
      :columns="columnsList"
      :isnt-checkable="true"
      :filter-data="true"
      @filter-date="setFilter"
    />
  </section>
</template>

<script>
import TableList from '@/components/shared/table/TableList'
import { mapActions, mapGetters } from 'vuex'
import { TiposDocumentos } from '../../mixins/tipos-documentos'
import router from '@/router'
import { NotAuthenticatedError } from '../../models/not-authenticated-error'
import { format } from 'date-fns'

export default {
  name: 'DocumentosRelatorios',
  components: { tablelist: TableList },
  data() {
    return {
      columnsList: [
        {
          field: 'date',
          label: 'Data'
        },
        {
          field: 'description',
          label: 'Descrição'
        },
        {
          field: 'id',
          label: 'Action'
        }
      ]
    }
  },
  computed: {
    ...mapGetters({
      getDates: 'getDateFilter',
      getRelatorios: 'getRelatorios'
    })
  },
  created() {
    this.setFilter()
  },
  methods: {
    ...mapActions(['obterRelatorios']),
    setFilter() {
      let payload = {
        type: TiposDocumentos.Relatorio,
        initDate: this.getDates.initDate,
        endDate: this.getDates.endDate
      }
      if (!payload.initDate) {
        payload.initDate = format(new Date(0), 'dd/MM/yyyy')
      }
      if (!payload.endDate) {
        payload.endDate = format(new Date(), 'dd/MM/yyyy')
      }
      this.obterRelatorios({ ...payload }).catch((err) => {
        if (err instanceof NotAuthenticatedError) router.push('/')
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/stylesheets/base';
@import '~@/assets/stylesheets/document';

.align {
  .text {
    p {
      margin-bottom: 2.5rem;
    }
  }
}

@media (max-width: 64rem) {
  .align {
    margin-top: 3rem;

    .img {
      margin: 0;
      display: flex;
      justify-content: center;
    }

    .text {
      padding: 0;
      margin-top: 1.5rem;
    }
  }
}

@media (max-width: 64rem) {
  .align {
    margin-top: 3rem;

    .img {
      margin: 0;
      display: flex;
      justify-content: center;
    }

    .text {
      padding: 0;
      margin-top: 1.5rem;
    }
  }
}

@media (min-width: 64rem) {
  .align {
    padding-left: 10%;
    padding-right: 10%;
  }
}
</style>
